(() => {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js', 'is-ready');

  const header = document.querySelector('[data-site-header]');
  const menu = document.querySelector('[data-mobile-menu]');
  const openMenu = document.querySelector('[data-open-menu]');
  const closeMenu = document.querySelector('[data-close-menu]');

  const syncHeader = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  const setMenu = (isOpen) => {
    if (!menu || !openMenu) return;
    menu.classList.toggle('is-open', isOpen);
    openMenu.setAttribute('aria-expanded', String(isOpen));
    document.documentElement.style.overflow = isOpen ? 'hidden' : '';
  };

  window.addEventListener('scroll', syncHeader, { passive: true });
  syncHeader();

  openMenu?.addEventListener('click', () => setMenu(true));
  closeMenu?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 })
    : null;

  const motionSelectors = [
    '.reveal',
    '.product-card',
    '.collection-feature-row',
    '.collection-feature-row__image',
    '.collection-editorial-tile',
    '.section-banner',
    '.section-heading',
    '.split-editorial__copy',
    '.category-feature-grid__item',
    '.store-feature__card',
    '.marquee',
    '.main-page__inner',
    '.pdp__summary-inner > *',
    '.pdp-look__tile',
    '.pdp-related .product-card',
    '.pdp-recently-viewed .product-card',
    '.recent-product-card',
    '.main-cart__title',
    '.main-cart__item',
    '.main-cart__footer',
    '.main-cart__empty',
    '.site-footer__menu',
    '.site-footer__socials',
    '.site-footer__copyright',
  ].join(',');

  const observeMotionNode = (node) => {
    if (!node || node.dataset.motionObserved === 'true') return;
    node.dataset.motionObserved = 'true';
    if (observer) observer.observe(node);
    else node.classList.add('is-visible');
  };

  const prepareMotion = (root = document) => {
    const nodes = [];
    if (root.matches?.(motionSelectors)) nodes.push(root);
    nodes.push(...root.querySelectorAll?.(motionSelectors) || []);

    nodes.forEach((node, index) => {
      node.classList.add('motion-item');
      node.style.setProperty('--motion-index', String(Math.min(index, 10)));
      observeMotionNode(node);
    });
  };

  prepareMotion();

  const animatedBanners = Array.from(document.querySelectorAll('.template-index .section-banner, .template-index .category-feature-grid__item'));
  let bannerTicking = false;

  const syncBannerMotion = () => {
    bannerTicking = false;
    if (!animatedBanners.length) return;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    animatedBanners.forEach((banner) => {
      const rect = banner.getBoundingClientRect();
      const total = rect.height + viewportHeight;
      const rawProgress = (viewportHeight - rect.top) / total;
      const progress = Math.min(1, Math.max(0, rawProgress));
      const inView = rect.bottom > 0 && rect.top < viewportHeight;

      banner.classList.toggle('is-scroll-active', inView);
      banner.style.setProperty('--banner-progress', progress.toFixed(4));
      banner.style.setProperty('--banner-drift', `${((progress - 0.5) * 28).toFixed(2)}px`);
      banner.style.setProperty('--banner-tilt', `${((progress - 0.5) * -1.4).toFixed(3)}deg`);
    });
  };

  const requestBannerMotion = () => {
    if (bannerTicking) return;
    bannerTicking = true;
    window.requestAnimationFrame(syncBannerMotion);
  };

  if (animatedBanners.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('scroll', requestBannerMotion, { passive: true });
    window.addEventListener('resize', requestBannerMotion);
    requestBannerMotion();
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.hash && url.pathname === window.location.pathname) return;
    document.documentElement.classList.add('is-leaving');
  });

  window.addEventListener('pageshow', () => {
    document.documentElement.classList.remove('is-leaving');
  });

  const maxCartQuantity = 30;
  const clampQuantityInput = (input) => {
    if (!input) return;
    const min = Number(input.getAttribute('min') || 0);
    const max = Number(input.getAttribute('max') || maxCartQuantity);
    const current = Number(input.value || min);
    if (!Number.isFinite(current)) {
      input.value = String(min);
      return;
    }
    input.value = String(Math.min(max, Math.max(min, Math.floor(current))));
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest('input[name="quantity"], input[name="updates[]"], [data-cart-quantity-input]');
    if (!input) return;
    if (!input.hasAttribute('max')) input.setAttribute('max', String(maxCartQuantity));
    clampQuantityInput(input);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('input[name="quantity"], input[name="updates[]"], [data-cart-quantity-input]');
    if (!input) return;
    if (!input.hasAttribute('max')) input.setAttribute('max', String(maxCartQuantity));
    clampQuantityInput(input);
  });

  document.addEventListener('submit', (event) => {
    event.target.querySelectorAll?.('input[name="quantity"], input[name="updates[]"], [data-cart-quantity-input]').forEach((input) => {
      if (!input.hasAttribute('max')) input.setAttribute('max', String(maxCartQuantity));
      clampQuantityInput(input);
    });
  }, true);

  document.querySelectorAll('input[name="quantity"], input[name="updates[]"], [data-cart-quantity-input]').forEach((input) => {
    if (!input.hasAttribute('max')) input.setAttribute('max', String(maxCartQuantity));
    clampQuantityInput(input);
  });

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-load-more]');
    if (!trigger) return;

    const collectionPage = trigger.closest('[data-collection-page]');
    const rows = collectionPage?.querySelector('[data-collection-rows]');
    const pagination = trigger.closest('[data-collection-pagination]');
    if (!collectionPage || !rows || !pagination) return;

    event.preventDefault();
    if (trigger.getAttribute('aria-busy') === 'true') return;

    const originalText = trigger.textContent;
    const nextUrl = new URL(trigger.href, window.location.href);
    const currentUrl = new URL(window.location.href);
    const previewThemeId = currentUrl.searchParams.get('preview_theme_id');
    if (previewThemeId && !nextUrl.searchParams.has('preview_theme_id')) {
      nextUrl.searchParams.set('preview_theme_id', previewThemeId);
    }

    trigger.setAttribute('aria-busy', 'true');
    trigger.textContent = trigger.dataset.loadingText || 'Loading...';

    try {
      const response = await fetch(nextUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Failed to load ${nextUrl.pathname}`);

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextRows = nextDocument.querySelector('[data-collection-rows]');
      const nextPagination = nextDocument.querySelector('[data-collection-pagination]');

      if (!nextRows) throw new Error('Next collection rows were not found');

      Array.from(nextRows.children).forEach((row) => {
        const importedRow = document.importNode(row, true);
        rows.appendChild(importedRow);
        prepareMotion(importedRow);
      });

      if (nextPagination) {
        pagination.replaceWith(document.importNode(nextPagination, true));
      } else {
        pagination.remove();
      }
    } catch (error) {
      trigger.removeAttribute('aria-busy');
      trigger.textContent = originalText;
      console.error(error);
    }
  });

  const formatMoney = (cents, format) => {
    const value = Number(cents || 0) / 100;
    const amount = value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const amountNoDecimals = Math.round(value).toLocaleString();
    return (format || 'Rs. {{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  document.querySelectorAll('[data-product-page]').forEach((page) => {
    const variantsNode = page.querySelector('[data-product-variants]');
    const form = page.querySelector('.pdp__form');
    const variantInput = page.querySelector('[data-variant-id]');
    const price = page.querySelector('[data-product-price]');
    const addButton = page.querySelector('[data-add-to-cart]');
    const addLabel = page.querySelector('[data-add-label]');
    const gallery = page.querySelector('[data-pdp-gallery]');
    const currentProductNode = page.querySelector('[data-current-product]');
    const recentlyViewedSection = page.querySelector('[data-recently-viewed-section]');
    const recentlyViewedGrid = page.querySelector('[data-recently-viewed-grid]');
    if (!variantsNode || !form || !variantInput || !addButton) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      console.error(error);
      return;
    }

    const optionGroups = Array.from(page.querySelectorAll('[data-product-option]'));
    const selectedOptions = () => optionGroups.map((group) => {
      const checked = group.querySelector('[data-option-value]:checked');
      return checked?.value || '';
    });

    const syncAvailability = () => {
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach((input) => {
          const trial = selectedOptions();
          trial[groupIndex] = input.value;
          const hasVariant = variants.some((variant) => {
            return variant.available && trial.every((value, index) => !value || variant.options?.[index] === value);
          });
          input.disabled = !hasVariant;
        });
      });
    };

    const syncVariant = () => {
      const options = selectedOptions();
      const variant = variants.find((candidate) => {
        return options.every((value, index) => candidate.options?.[index] === value);
      });

      if (!variant) {
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = addButton.dataset.soldOutLabel || 'Sold Out';
        syncAvailability();
        return;
      }

      variantInput.value = variant.id;
      addButton.disabled = !variant.available;
      if (price) price.textContent = formatMoney(variant.price, page.dataset.moneyFormat);
      if (addLabel) {
        addLabel.textContent = variant.available
          ? (addButton.dataset.availableLabel || 'Add To Cart')
          : (addButton.dataset.soldOutLabel || 'Sold Out');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      syncAvailability();
    };

    optionGroups.forEach((group) => {
      group.addEventListener('change', syncVariant);
    });
    syncVariant();

    if (gallery) {
      const slides = Array.from(gallery.querySelectorAll('.pdp__media'));
      const mediaQuery = window.matchMedia('(max-width: 989px)');
      let galleryTimer;
      let galleryIndex = 0;

      const stopGallery = () => {
        if (galleryTimer) window.clearInterval(galleryTimer);
      };

      const scrollGallery = (index) => {
        if (!slides.length) return;
        galleryIndex = (index + slides.length) % slides.length;
        gallery.scrollTo({
          left: slides[galleryIndex].offsetLeft,
          behavior: 'smooth',
        });
      };

      const startGallery = () => {
        stopGallery();
        if (!mediaQuery.matches || gallery.dataset.mobileAutoplay !== 'true' || slides.length < 2) return;
        const interval = Number(gallery.dataset.mobileInterval || 5000);
        galleryTimer = window.setInterval(() => scrollGallery(galleryIndex + 1), interval);
      };

      gallery.addEventListener('scroll', () => {
        if (!mediaQuery.matches || !slides.length) return;
        const nextIndex = Math.round(gallery.scrollLeft / gallery.clientWidth);
        galleryIndex = Math.max(0, Math.min(slides.length - 1, nextIndex));
      }, { passive: true });
      gallery.addEventListener('pointerdown', stopGallery);
      gallery.addEventListener('pointerup', startGallery);
      gallery.addEventListener('pointercancel', startGallery);
      mediaQuery.addEventListener?.('change', startGallery);
      startGallery();
    }

    if (currentProductNode) {
      const storageKey = 'forfksake:recentlyViewed';
      const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      }[char]));

      try {
        const currentProduct = JSON.parse(currentProductNode.textContent || '{}');
        const storedProducts = JSON.parse(window.sessionStorage.getItem(storageKey) || '[]');
        const previousProducts = storedProducts.filter((item) => item && item.id !== currentProduct.id);
        const limit = Number(recentlyViewedSection?.dataset.limit || 4);
        const productsToRender = previousProducts.slice(0, limit);

        if (recentlyViewedSection && recentlyViewedGrid && productsToRender.length) {
          recentlyViewedGrid.innerHTML = productsToRender.map((item) => {
            const image = item.image
              ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
              : '';
            return `
              <article class="recent-product-card">
                <a class="recent-product-card__media" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(item.title)}">${image}</a>
                <div class="recent-product-card__info">
                  <h3 class="recent-product-card__title"><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h3>
                  <p class="recent-product-card__price">${escapeHtml(item.price)}</p>
                </div>
              </article>
            `;
          }).join('');
          recentlyViewedSection.hidden = false;
          prepareMotion(recentlyViewedSection);
        }

        const nextProducts = [currentProduct, ...previousProducts].slice(0, 12);
        window.sessionStorage.setItem(storageKey, JSON.stringify(nextProducts));
      } catch (error) {
        console.error(error);
      }
    }
  });

  document.querySelectorAll('[data-store-feature]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-store-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-store-dot]'));
    const previous = carousel.querySelector('[data-store-prev]');
    const next = carousel.querySelector('[data-store-next]');
    if (slides.length < 2) return;

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;
    let autoplayTimer;

    const setActive = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    };

    const stopAutoplay = () => {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (carousel.dataset.autoplay !== 'true') return;
      const interval = Number(carousel.dataset.interval || 5000);
      autoplayTimer = window.setInterval(() => setActive(activeIndex + 1), interval);
    };

    previous?.addEventListener('click', () => {
      setActive(activeIndex - 1);
      startAutoplay();
    });
    next?.addEventListener('click', () => {
      setActive(activeIndex + 1);
      startAutoplay();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        setActive(Number(dot.dataset.storeDot || 0));
        startAutoplay();
      });
    });
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    setActive(activeIndex);
    startAutoplay();
  });
})();
